<template>
  <view-wrapper name="Groups" :loading="loading" :loadingText="loadingText">
    <AuthorizationZone allowAny="AccountType:Administrator">
      <router-link class="mt-3 button big primary white" to="addgroup"
        >Create new group</router-link
      >
    </AuthorizationZone>

    <grafokett-button class="mt-3 small" @click="refreshGroups"
      >Refresh</grafokett-button
    >

    <filter-and-sort-box
      class="mt-10"
      :data="getGroups"
      :headers="headersGroup"
      @searchQuery="searchText = $event"
    >
      <template v-slot:d="{ d }">
        <td colspan="2">
          <TreeItem
            class="flex flex-col w-full"
            :data="d"
            v-slot:default="slotProps"
            :classMethod="() => treeItemStyles"
          >
            <span class="flex-1">
              {{ slotProps.group.groupName }}
            </span>
            <span class="flex-1">
              {{ slotProps.group.modified }}
            </span>
            <div>
              <grafokett-button
                class="small"
                @click.stop="editGroup(slotProps.group)"
                >Edit <i style="font-size: 2em" class="edit-symbol"
              /></grafokett-button>
            </div>
          </TreeItem>
        </td>
      </template>
    </filter-and-sort-box>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import FilterAndSortBox from "../components/FilterAndSortBox";
import AuthorizationZone from "../components/AuthorizationZone";
import TreeItem from "../components/TreeItem";

export default {
  components: {
    GrafokettButton,
    FilterAndSortBox,
    AuthorizationZone,
    TreeItem
  },
  data() {
    return {
      headersGroup: {
        groupName: "Group name",
        modified: "Last edited"
      },
      loading: false,
      loadingText: "List of groups",
      searchText: ""
    };
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
    this.loading = false;
  },
  methods: {
    async editGroup(g) {
      await this.$router.push("/groups/" + g.id);
    },
    async refreshGroups() {
      this.loading = true;
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      this.loading = false;
    }
  },
  computed: {
    getGroups() {
      return this.$store.getters["GROUPS/GROUPS"].filter(
        x =>
          x.groupName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
    treeItemStyles() {
      return {
        primary: true,
        flex: true,
        "w-full": true,
        "items-center": true
      };
    }
  }
};
</script>
